import { Button, useTheme } from "@mui/material";
import { authFlowHeaderIcons } from "./authFlowHeaderIcons";
import {
  getLoginPrimaryButtonSx,
  LoginCardContent,
  LoginFormHeader,
} from "./loginUi";

export type ChangePasswordCompleteProps = {
  homeUrl?: string;
  translations: {
    passwordChangeComplete: string;
    passwordChangeCompleteDescription: string;
    continueToCube: string;
  };
};

export const ChangePasswordComplete = ({
  homeUrl = "/",
  translations: t,
}: ChangePasswordCompleteProps) => {
  const theme = useTheme();

  return (
    <LoginCardContent testId="change-password-complete">
      <LoginFormHeader
        title={t.passwordChangeComplete}
        subtitle={t.passwordChangeCompleteDescription}
        headerIcon={authFlowHeaderIcons.changePasswordComplete}
        headerTestId="change-password-complete-header"
        titleTestId="change-password-complete-title"
        headerIconTestId="change-password-complete-header-icon"
      />

      <Button
        href={homeUrl}
        fullWidth
        variant="contained"
        size="large"
        data-testid="continue-to-cube-button"
        sx={getLoginPrimaryButtonSx(theme)}
      >
        {t.continueToCube}
      </Button>
    </LoginCardContent>
  );
};
